import { render, staticRenderFns } from "./VolunteerMatchView.vue?vue&type=template&id=4aaba266"
import script from "./VolunteerMatchView.vue?vue&type=script&lang=ts"
export * from "./VolunteerMatchView.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerMatchView.vue?vue&type=style&index=0&id=4aaba266&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports